import React from 'react';
import LunarCalendarApp from './components/LunarCalendarApp';

function App() {
  return <LunarCalendarApp />;
}

export default App;